import React, { Component } from 'react';
import { connect } from 'react-redux'
import DriverDetailsComponent from '../../components/driverDetails';
import moment from 'moment'

import * as actions from './actions'

import './styles.css'
import { opdbGTM } from '../../utils/pulseUtils';

class DriverDetailsContainer extends Component{
  constructor(props){
    super(props);
    this.state = {
      source: null,
      destination: null,
      selectedServices: [],
      journeyDate: null,
      focusedJourneyDate: false,
      currentDate: moment().format('DD-MMM-YYYY')
    }
  }

  componentDidMount(){
    opdbGTM.tabClicked('od_driver_details_tab_clicked');
  }

  componentWillUnmount(){
    this.props.clearDriverDetails();
  }

  onSourceItemSelect = (item) => {
    this.setState({ source: item })
  }

  onDestinationItemSelect = (item) => {
    this.setState({ destination: item })
  }

  fetchCities = (value, fieldType) => {
    this.props.fetchCities(value, fieldType);
  }

  onSearchClick = () => {
    const { source, destination, journeyDate } = this.state;
    if(!source || !destination) {
      alert('Please select a valid value of source and destination.');
      return;
    }
    this.props.fetchServices({
      srcId: source.city_id,
      destId: destination.city_id,
      journey_date: journeyDate? journeyDate.format('YYYY-MM-DD'): undefined
    });
    opdbGTM.driverDetailsSearchClicked();
  }

  onJourneyDateChange = date => this.setState({ journeyDate: date })

  onJourneyDateFocusChange = ({ focused }) => this.setState({ focusedJourneyDate: focused })

  journeyDateRangeChecker = (date) => moment().diff(date) > 0

  onServicesSelection = (routeTimeId, isChecked) => {
    this.setState(prevState => ({
      selectedServices: isChecked?
        prevState.selectedServices.concat(routeTimeId)
        : prevState.selectedServices.filter(el => el != routeTimeId)
    }))
  }

  onSaveClick = (tripDetails) => {
    // { "tripId" : { "driverDetails": {}, "serviceDetails": {}}}
    let dataForSaveAPI = [];
    Object.keys(tripDetails).forEach((tripId) => {
      let tripDetail = tripDetails[tripId];
      let dataPerTripId = this.prepareDataForSaveAPI(tripDetail.serviceInfo ,tripDetail.driverInfo );
      dataForSaveAPI.push(dataPerTripId);
    })

    this.props.updateDriverDetails(dataForSaveAPI);
  }

  prepareDataForSaveAPI = ( serviceInfo, driverInfo ) => {
    let providerId = serviceInfo.provider_id;
    let operatorId = serviceInfo.operator_id;
    let tripId = serviceInfo.trip_id;
    let journeyDate = serviceInfo.info.journeyDate;
    let driverName = driverInfo.driverName;
    let vehicleNumber = driverInfo.vehicleNumber;
    let phoneNumbers = []

    if(driverInfo.driverPhoneNumber) {
      phoneNumbers.push(driverInfo.driverPhoneNumber);
    }

    if(driverInfo.driverAltPhoneNumber) {
      phoneNumbers.push(driverInfo.driverAltPhoneNumber);
    }

    return {
      providerId,
      operatorId,
      tripId,
      journeyDate,
      info: {
        driverInfo: [
          {
            driverName,
            phoneNumbers
          }
        ],
        vehicleNumber
      }
    }
  }

  render() {
    return(
      <div className="updateDriverDetailsContainer">

        <div className="row updateDriverDetailsHeader">
          <p className="updateDriverDetailsHeading">Update Driver Details</p>
          <p className="updateDriverDetailsDate">{this.state.currentDate}</p>
        </div>

        <DriverDetailsComponent
          onSourceItemSelect={this.onSourceItemSelect}
          onDestinationItemSelect={this.onDestinationItemSelect}
          sourceCityData={this.props.sourceCityData}
          destCityData={this.props.destCityData}
          routeServices={this.props.routeServices}
          fetchCities={this.fetchCities}
          onSearchClick={this.onSearchClick}
          journeyDate={this.state.journeyDate}
          onJourneyDateChange={this.onJourneyDateChange}
          focusedJourneyDate={this.state.focusedJourneyDate}
          onJourneyDateFocusChange={this.onJourneyDateFocusChange}
          journeyDateRangeChecker={this.journeyDateRangeChecker}
          onServicesSelection={this.onServicesSelection}
          selectedServices={this.state.selectedServices}
          onSaveClick={this.onSaveClick}
        />
      </div>
    )
  }
}

const mapStateToProps = store => ({
  routeServices: store.updateDriverDetailsReducer.routeServices,
  sourceCityData: store.updateDriverDetailsReducer.sourceCityData,
  destCityData: store.updateDriverDetailsReducer.destCityData,
})

const mapDispatchToProps = dispatch => ({
  fetchServices: (query) => dispatch(actions.fetchServices(query)),
  fetchCities: (queryStr, fieldType) => dispatch(actions.fetchCities(queryStr, fieldType)),
  updateDriverDetails: (data, callback) => dispatch(actions.updateDriverDetails(data, callback)),
  clearDriverDetails: () => dispatch(actions.clearDriverDetails())
})

export default connect(mapStateToProps, mapDispatchToProps)(DriverDetailsContainer)
